import React from 'react';
import {ListItemIcon, ListItemText, Menu, MenuItem, Tooltip} from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

// Props:
// - anchorEl, open, onClose
// - role: 'owner' | 'editor' | 'collaborator' | 'viewer' | null
// - onExport, onShareOpen, onDeleteOpen
export default function ReportActionsMenu({
                                              anchorEl,
                                              open,
                                              onClose,
                                              role,
                                              onExport,
                                              onShareOpen,
                                              onDeleteOpen
                                          }) {
    const handleCloseAnd = (fn) => () => {
        if (typeof onClose === 'function') onClose();
        if (typeof fn === 'function') fn();
    };

    const canShare = role === 'owner';
    const canSeeShare = role === 'owner' || role === 'editor' || role === 'collaborator';

    return (
        <Menu
            id="report-actions-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
        >
            <MenuItem onClick={handleCloseAnd(onExport)}>
                <ListItemIcon>
                    <FileDownloadOutlinedIcon fontSize="small"/>
                </ListItemIcon>
                <ListItemText>Export</ListItemText>
            </MenuItem>

            {canSeeShare && (
                <Tooltip
                    title={canShare ? '' : 'Only the owner can share this report'}
                    placement="left"
                    disableHoverListener={canShare}
                    disableFocusListener={canShare}
                    disableTouchListener={canShare}
                >
                    <span>
                        <MenuItem
                            onClick={canShare ? handleCloseAnd(onShareOpen) : undefined}
                            disabled={!canShare}
                        >
                            <ListItemIcon>
                                <ShareOutlinedIcon fontSize="small"/>
                            </ListItemIcon>
                            <ListItemText>Share</ListItemText>
                        </MenuItem>
                    </span>
                </Tooltip>
            )}

            {role === 'owner' && (
                <MenuItem onClick={handleCloseAnd(onDeleteOpen)} sx={{color: 'error.main'}}>
                    <ListItemIcon>
                        <DeleteOutlineIcon fontSize="small" sx={{color: 'error.main'}}/>
                    </ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                </MenuItem>
            )}
        </Menu>
    );
}

